module.exports = __webpack_public_path__ + "img/Dexterity.d9b90333.png";